import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTracker } from '@dpdgroupuk/react-event-tracker';

import { wrapPromise } from '../../../utils/promise';
import {
  getAvailableMergeSplitStops,
  getSelectedStops,
  getLeadStop,
} from '../../../store/selectors/ui/routeDetail';
import { mergeStops, onMergeStopPick } from '../../../store/actions/stop';
import { ROUTE_MANAGEMENT } from '../../../constants/analytics';
import modals from '../../../enums/modals';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';

export default () => {
  const dispatch = useDispatch();
  const tracker = useTracker();
  const { getModalRef } = useModalContext();

  const dropdownListStops = useSelector(getAvailableMergeSplitStops);
  const selectedStops = useSelector(getSelectedStops);
  const leadStop = useSelector(getLeadStop);

  const handleMergeStopPick = useCallback(
    (pickedStop) => dispatch(onMergeStopPick(pickedStop)),
    [dispatch]
  );

  const openMergeStopsModal = useCallback(async () => {
    tracker.logEvent(ROUTE_MANAGEMENT.CLICK_MERGE);
    const mergeStopsModalRef = getModalRef(modals.MERGE_STOPS);
    const [processedData, canceled] = await wrapPromise(
      mergeStopsModalRef.current.showModal({
        availableStops: dropdownListStops,
        selectedStops,
        leadStop,
        handleMergeStopPick,
      })
    );
    if (canceled) {
      return;
    }
    const { stop, destinationStopNumber } = processedData;
    dispatch(mergeStops(stop, destinationStopNumber));
  }, [
    dispatch,
    tracker,
    dropdownListStops,
    handleMergeStopPick,
    selectedStops,
    leadStop,
  ]);

  return {
    openMergeStopsModal,
  };
};
